import React from 'react';
import styled from '@emotion/styled';
import { mq } from 'js/common/utils/mediaQueries';
import { palette } from '@leafygreen-ui/palette';

// components
import { PlacementProps } from './Layout';

// utils
import analytics, { SEGMENT_EVENTS } from 'js/project/common/util/segmentAnalytics';

const loginPromoDesktopAsset = 'url(/static/images/auth/login_promo_desktop.png)';
const loginPromoMobileAsset = 'url(/static/images/auth/login_promo_mobile.png)';

export const loginPromoAssets = [
  loginPromoMobileAsset,
  loginPromoMobileAsset,
  loginPromoDesktopAsset,
  loginPromoDesktopAsset,
];

export const loginPromoConfig = {
  TITLE: 'Deliver App Search Fast with Atlas Search',
  SUBTITLE:
    'Build rich full-text search features into your applications without syncing your database to a separate search engine.',
  CTA_DESKTOP_TEXT: 'Explore tutorial',
  CTA_MOBILE_TEXT: 'Explore Atlas Search tutorial',
  CTA_URL:
    'https://www.mongodb.com/developer/article/atlas-search-demo-restaurant-app?utm_campaign=atlas-search-demo-app',
  SEGMENT_CAMPAIGN_PROP: 'Atlas Search Demo Restaurant App',
};

const LoginPromoDesktopTitle = styled.div(() =>
  mq({
    color: palette.white,
    fontWeight: 'bold',
    fontSize: ['23px', '23px', '23px', '32px'],
    lineHeight: ['31px', '31px', '31px', '40px'],
    width: ['370px', '270px', '270px'],
    maxWidth: '100%',
  })
);

const LoginPromoDesktopSubtext = styled.div(() =>
  mq({
    color: palette.white,
    fontWeight: 'normal',
    fontSize: ['14px', '14px', '14px', '16px'],
    lineHeight: ['20px', '20px', '20px', '24px'],
    width: ['290px', '290px', '290px', '350px'],
    maxWidth: '100%',
    padding: ['16px 0px', '16px 0px', '24px 0px', '24px 0px'],
  })
);

const LoginPromoDesktopContainer = styled.div((props: PlacementProps) =>
  mq({
    display: ['none', 'none', 'flex', 'flex'],
    maxWidth: '100%',
    flexDirection: 'column',
    padding: '60px',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  })
);

const LoginPromoMobileContainer = styled.a(() =>
  mq({
    color: palette.white,
    fontSize: '15px',
    fontWeight: 'bold',
    lineHeight: '24px',
    textDecoration: 'none',
    display: ['none', 'flex', 'none', 'none'],
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  })
);

const LoginPromoCTAOuter = styled(LoginPromoMobileContainer)(() =>
  mq({
    width: 'fit-content',
    display: ['flex', 'none', 'flex', 'flex'],
    fontSize: ['13px', '13px', '13px', '16px'],
    lineHeight: '24px',
  })
);

const RightArrow = styled.span({
  color: palette.white,
  fontWeight: 'lighter',
  fontFamily: 'system-ui',
  paddingLeft: '10px',
  display: 'inline-block',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
});

const LoginPromoCTA = styled.span`
  color: ${palette.white};
  border-bottom: 1px solid;
  padding-bottom: 2px;
  display: inline-block;
  font-weight: bold;
  &:hover {
    color: ${palette.gray.light2};
  }
`;

const trackCTAClicked = () => {
  analytics.track(SEGMENT_EVENTS.UX_ACTION_PERFORMED, {
    context: 'Cloud Login Page',
    action: 'Login Page CTA Clicked',
    campaign: loginPromoConfig.SEGMENT_CAMPAIGN_PROP,
  });
};

export function LoginPromo(props: PlacementProps) {
  const { placement } = props;
  return (
    <>
      <LoginPromoDesktopContainer placement={placement}>
        <LoginPromoDesktopTitle>{loginPromoConfig.TITLE}</LoginPromoDesktopTitle>
        <LoginPromoDesktopSubtext>{loginPromoConfig.SUBTITLE}</LoginPromoDesktopSubtext>
        <LoginPromoCTAOuter
          href={loginPromoConfig.CTA_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={trackCTAClicked}
        >
          <LoginPromoCTA>{loginPromoConfig.CTA_DESKTOP_TEXT}</LoginPromoCTA>
          <RightArrow>&#8594;</RightArrow>
        </LoginPromoCTAOuter>
      </LoginPromoDesktopContainer>
      <LoginPromoMobileContainer
        onClick={trackCTAClicked}
        href={loginPromoConfig.CTA_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <LoginPromoCTA>{loginPromoConfig.CTA_MOBILE_TEXT}</LoginPromoCTA>
        <RightArrow>&#8594;</RightArrow>
      </LoginPromoMobileContainer>
    </>
  );
}
